import React from 'react';
import Header from './Header';
import './App.css';

const App = () => (
  <div className="App">
    <Header />
  </div>
);

export default App;
